import React from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';

interface Props {}

const H: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.H');

    return (
        <section
            id="rapid-mag-H"
            className={`rapid-mag-H ${css.section} GtmModuleData-section`}
            data-section-id={'rapid-mag-H'}
            data-section-title={t('title')}
        >
            <div className="img">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/figma-uploads/1762506234455-h2pcgl-compressed-Frame%201000008585.jpg"
                    pad="https://websiteoss.ecoflow.com/figma-uploads/1762506234455-h2pcgl-compressed-Frame%201000008585.jpg"
                    h5="https://websiteoss.ecoflow.com/figma-uploads/1762506214359-1c5yxu-compressed-Frame%201612707983.jpg"
                />
            </div>
            <div className="info">
                <p className="title">{t('title')}</p>
                <p className="subtitle">{t('subtitle')}</p>
                <p className="desc">{t('desc')}</p>
            </div>
        </section>
    );
};
export default H;
